"use client";
import React from "react";
import { useProductDetailsContext } from "@/src/provider";
import { tranColorByName } from "@/lib/commonService";
import { useTranslation } from "@/src/i18n/client";

interface Props {
    // Define your component props here
}

const ColorTitleTextClient: React.FC<Props> = () => {
    // Your component logic goes here
    const { t } = useTranslation("common");
    const [activeObj] = useProductDetailsContext((state) => [state.activeObj]);
    return `${tranColorByName({
        t,
        color_name: activeObj.name,
    })}(${activeObj.colorNum})`;
};

export default ColorTitleTextClient;
